import React, { useEffect, useState } from 'react';
import { Row, Col, FormInput, FormRadioGroup } from '@snsw/react-component-library';
import { isEmpty, isNumeric, validateExt } from 'shared/utils/Validation';
import styles from '../PlantItemDetails.module.scss';
import { RefData } from 'plantItemNew/constants/refData';
import { PlantItemDetailsPage } from 'plantItemNew/constants/plantItemDetailsPage';

export const ConcretePlacingUnitDetails = React.forwardRef((props, ref) => {
  const { value = {}, onChange = () => {}, refData = {}, onErrorChange = () => {} } = props;
  const { concretePlacingUnitType: savedConcretePlacingUnitType = '', maxBoomLength: savedMaxBoomLength = '' } = value;
  const [concretePlacingUnitType, setConcretePlacingUnitType] = useState(savedConcretePlacingUnitType);
  const [maxBoomLength, setMaxBoomLength] = useState(savedMaxBoomLength);

  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState({});
  const [errorSummary, setErrorSummary] = useState([]);

  const validators = [
    {
      fieldName: 'concretePlacingUnitType',
      fieldValue: concretePlacingUnitType,
      isValid: (v) => !isEmpty(v),
      errorMessage: () => 'Please select an option',
    },
    {
      fieldName: 'maxBoomLength',
      fieldValue: maxBoomLength,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
  ];

  const concretePlacingUnitTypeOptions = Array.isArray(refData[RefData.concretePlacingBoom.subTypeOptions])
    ? refData[RefData.concretePlacingBoom.subTypeOptions].map((e) => ({
        value: e.value,
        label: e.description,
      }))
    : [];

  if (ref) {
    ref.current = {
      validate: () => {
        let isCurrentComponentValid = validateExt(validators, setErrors, setErrorSummary);

        setShowErrors(!isCurrentComponentValid);

        return isCurrentComponentValid;
      },
    };
  }

  useEffect(() => {
    let details = {
      concretePlacingUnitType,
      maxBoomLength,
    };
    onChange(details);

    if (showErrors) validateExt(validators, setErrors, setErrorSummary);
  }, [concretePlacingUnitType, maxBoomLength]);

  useEffect(() => {
    onErrorChange(errorSummary);
  }, [errorSummary]);

  return (
    <>
      <Row>
        <Col span={4}>
          <FormRadioGroup
            id="concretePlacingUnitType"
            name="concretePlacingUnitType"
            legend={PlantItemDetailsPage.relatedDetails.concretePlacingUnit.concretePlacingUnitTypeLabel}
            options={concretePlacingUnitTypeOptions}
            value={concretePlacingUnitType}
            errorMessage={errors?.concretePlacingUnitType?.errorMessage}
            hasError={showErrors && errors?.concretePlacingUnitType?.invalid}
            onChange={setConcretePlacingUnitType}
            vertical={true}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: 20 }}>
        <Col span={4}>
          <FormInput
            id="maxBoomLength"
            label={PlantItemDetailsPage.relatedDetails.concretePlacingUnit.maxBoomLengthLabel}
            suffix="m"
            onChange={(e, { value }) => setMaxBoomLength(value)}
            value={maxBoomLength}
            errorMessage={errors?.maxBoomLength?.errorMessage}
            hasError={showErrors && errors?.maxBoomLength?.invalid}
            className={styles.inputWithSuffix}
          />
        </Col>
      </Row>
    </>
  );
});

ConcretePlacingUnitDetails.displayName = 'ConcretePlacingUnitDetails';
